// import axios from 'axios'
import { collection, getDocs, addDoc, query, where } from 'firebase/firestore'
import { db, app } from './firebase'
import { getAnalytics } from 'firebase/analytics'
import { groupBy } from 'lodash'

// export function getting() {
//   console.log('getting')
//   axios
//     .get('https://sheet.best/api/sheets/b3439b34-5c7c-47e8-aa20-b624e1ab3e06')
//     .then(
//       (response) =>
//         // {
//         // console.log('response get', response.status)
//         response.data
//       // }
//     )
// }

// export function saving(e) {
//   console.log('function post', e)
//   axios
//     .post(
//       'https://sheet.best/api/sheets/b3439b34-5c7c-47e8-aa20-b624e1ab3e06',
//       e
//     )
//     .then((response) => {
//       console.log('response save', response.status)
//     })
// }

// export function editing(e, id) {
//   console.log('editing', e)
//   axios
//     .patch(
//       `https://sheet.best/api/sheets/b3439b34-5c7c-47e8-aa20-b624e1ab3e06/id/${id}`
//     )
//     .then((response) => {
//       console.log('response edit', response.status)
//     })
// }

// FUNCTION TO EDIT OR SAVE DATA ON COUNTRIES DATABASES
function setCountryDb(country) {
  switch (country) {
    case 'ecu':
      return 'survey_ecuador'
    case 'col':
      return 'survey_colombia'
    case 'bra':
      return 'survey_brasil'
    case 'per':
      return 'survey_peru'
    case 'fr':
      return 'survey_france'
    case 'uk':
      return 'survey_uk'
    case 'us':
      return 'survey_us'
    default:
      return 'phdSurvey'
  }
}

// FUNCTION TO MAP GROUPED OBJECTS
function mapObject(data) {
  var obj = Object.keys(data).map((item) => {
    return {
      [item]: data[item].length,
    }
  })
  return obj
}

// GETTING FULL DATA
export async function getFireData(cntry) {
  const dbCntry = setCountryDb(cntry)
  // getAnalytics(app)
  const querySnapshot = await getDocs(collection(db, dbCntry))
  var data = []
  querySnapshot.forEach((doc) => {
    // console.log(`${doc.id} => ${doc.data()}`)
    data.push({ ...doc.data(), idFire: doc.id })
  })
  return data
}

// SAVING DOCUMENT ON COLLECTION
export async function postFireData(e, cntry) {
  const dbCntry = setCountryDb(cntry)
  getAnalytics(app)
  try {
    const docRef = await addDoc(collection(db, dbCntry), e)
    return docRef
    // console.log('Document written with ID: ', docRef.id)
  } catch (e) {
    console.error('Error adding document: ', e)
  }
}

// CHECKING DATABASES QUOTAS
export async function checkUserQuotas(id, rangeAge, gender, cntry) {
  // QUOTAS
  const quotasList = {
    man: 350,
    woman: 350,
    '18_24': 175,
    '25_34': 210,
    '35_49': 175,
    '50_65': 140,
  }
  var redirect = false
  // var data = []
  const dbCntry = setCountryDb(cntry)
  const theCol = collection(db, dbCntry)
  // if (cntry === 'col' || cntry === 'per' || cntry ==='bra') {
  // GETTING DATABASE BY COUNTRY
  const genCod = gender == '1' ? 'man' : gender == '2' ? 'woman' : ''
  // Getting DATABASE
  // const querySnapshot = await getDocs(theCol)
  // querySnapshot.forEach((doc) => {
  //   data.push({ ...doc.data(), idFire: doc.id })
  // })

  //COMPARING AGE

  const dataAgeBef = await getDocs(
    query(theCol, where('rangeAge', '==', rangeAge))
  )
  const quotaAgeVsUser =
    ((dataAgeBef || {}).docs || []).length >= quotasList[rangeAge]

  // const dataAge = mapObject(groupBy(data, 'rangeAge'))
  // const compareAge = dataAge.filter((item) => {
  //   const cles = Object.keys(item)
  //   return cles == rangeAge
  // })
  // const quotaAgeVsUser =
  //   (compareAge || []).length > 0
  //     ? compareAge[0][rangeAge] >= quotasList[rangeAge]
  //     : false

  // COMPARING GENDER

  const dataGenderBef = await getDocs(
    query(theCol, where('gender', '==', genCod))
  )
  const quotaGenVsUser =
    ((dataGenderBef || {}).docs || []).length >= quotasList[genCod]

  // const dataGen = mapObject(groupBy(data, 'gender'))
  // const compareGen = dataGen.filter((item) => {
  //   const cles = Object.keys(item)
  //   return cles == genCod
  // })
  // const quotaGenVsUser =
  //   (compareGen || []).length > 0
  //     ? compareGen[0][genCod] >= quotasList[genCod]
  //     : false

  // VERIF WHETHER USER EXIST
  // const filterUser = data.filter((itm) => itm.userId === id)
  // const userExist = filterUser.length > 0

  const dataIdBef = await getDocs(query(theCol, where('userId', '==', id)))
  const userExist = ((dataIdBef || {}).docs || []).length > 0
  // CONCLUSION REDIRECTING OR NOT
  redirect = true
  // || quotaAgeVsUser || quotaGenVsUser
  // } else {
  //   // VERIF WHETHER USER EXIST
  //   const dataIdBef = await getDocs(query(theCol, where('userId', '==', id)))
  //   const userExist = ((dataIdBef || {}).docs || []).length > 0
  //   redirect = redirect || userExist
  // }
  // DEFINE DISTANCE & CATEGORY
  const disCat = [
    { type: '01_near' },
    { type: '01_dis' },
    { type: '02_near' },
    { type: '02_dis' },
  ]
  // const nmbrStm = 175
  // const nearSport =
  //   (
  //     data.filter((item) => item.socDis === 'near' && item.catego === '01') ||
  //     []
  //   ).length > nmbrStm
  // const disSport =
  //   (data.filter((item) => item.socDis === 'dis' && item.catego === '01') || [])
  //     .length > nmbrStm

  // const nearTech =
  //   (
  //     data.filter((item) => item.socDis === 'near' && item.catego === '02') ||
  //     []
  //   ).length > nmbrStm
  // const disTech =
  //   (data.filter((item) => item.socDis === 'dis' && item.catego == '02') || [])
  //     .length > nmbrStm

  // const disCatDispo = disCat.filter(
  //   (itm) =>
  //     (nearSport ? itm.type !== '01_near' : true) &&
  //     (disSport ? itm.type !== '01_dis' : true) &&
  //     (nearTech ? itm.type !== '02_near' : true) &&
  //     (disTech ? itm.type !== '02_dis' : true)
  // )
  const selDisCat = Math.floor(Math.random() * disCat.length)
  const catDisSend = disCat[selDisCat]['type'].split('_')

  return [redirect, catDisSend[0], catDisSend[1]]
}

// CHECKING DATABASES ADVANCE QUOTAS
export async function checkAllQuotas(cntry) {
  // QUOTAS
  // const quotasList = {
  //   man: 350,
  //   woman: 350,
  //   '18_24': 175,
  //   '25_34': 210,
  //   '35_49': 175,
  //   '50_65': 140,
  // }
  // GETTING DATABASE BY COUNTRY
  const dbCntry = setCountryDb(cntry)
  // Getting DATABASE
  const querySnapshot = await getDocs(collection(db, dbCntry))
  var data = []
  querySnapshot.forEach((doc) => {
    data.push({ ...doc.data(), idFire: doc.id })
  })
  const times = data.map((itm) => itm.end)
  // console.log(times)
  console.log(data)
  // const fltrTme = data.map((itm) => itm.timeSurvey).filter((itm) => itm)
  // // 32 Person > de 16
  // const timed = fltrTme.reduce((a, b) => a + b, 0) / fltrTme.length
  // console.log(
  //   timed,
  //   fltrTme.sort(function(a, b) {
  //     return a - b
  //   })
  // )
  //COMPARING AGE
  const dataAge = mapObject(groupBy(data, 'rangeAge'))
  const compareAge = dataAge.filter((itm) => !itm.undefined && !itm.null)
  // COMPARING GENDER
  const dataGen = mapObject(groupBy(data, 'gender'))
  const compareGen = dataGen.filter((itm) => !itm.undefined && !itm.null)

  // DEFINE DISTANCE & CATEGORY
  // const disCat = [
  //   { type: '01_near' },
  //   { type: '01_dis' },
  //   { type: '02_near' },
  //   { type: '02_dis' },
  // ]
  // const nmbrStm = 175
  const nearSport = (
    data.filter((item) => item.socDis === 'near' && item.catego === '01') || []
  ).length
  const disSport = (
    data.filter((item) => item.socDis === 'dis' && item.catego === '01') || []
  ).length

  const nearTech = (
    data.filter((item) => item.socDis === 'near' && item.catego === '02') || []
  ).length
  const disTech = (
    data.filter((item) => item.socDis === 'dis' && item.catego == '02') || []
  ).length
  const datas = {
    ...compareAge[0],
    ...compareAge[1],
    ...compareAge[2],
    ...compareAge[3],
    // nearSport: nearSport,
    // disSport: disSport,
    // nearTech: nearTech,
    // disTech: disTech,
    ...compareGen[0],
    ...compareGen[1],
    ...compareGen[2],
  }
  return datas
}
